import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import {  MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatTooltipModule } from '@angular/material/tooltip';
import { PlApiModule } from '@common/pl-api.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import {
  PlSearchFilterComponent,
  PlListGridComponent,
  PlTableComponent,
  PlButtonComponent,
  PlInputComponent,
  PlInputFileComponent,
  ModalMessageComponent,
  PlProgressCircleComponent,
  PlCalendarHeaderComponent,
  PlInfoboxComponent,
  PlClientLinkComponent,
  LoadingAnimationComponent,
} from './components';
import { DateErrorPipe, PlaceholderTextPipe } from './pipes';
import { PlModalService, InternalAdminService } from './services';
import { PlUserService } from './entities';
import { UserProfileService } from './services/user-profile.service';
import {
  PlAccountEffects,
  reducer,
  featureKey,
  PLFeatureFlagEffects,
} from './store';

@NgModule({
  declarations: [
    PlSearchFilterComponent,
    PlListGridComponent,
    PlTableComponent,
    PlButtonComponent,
    PlInputFileComponent,
    PlInputComponent, // TODO: Maybe remove in the future only used for story book
    ModalMessageComponent,
    PlProgressCircleComponent,
    PlaceholderTextPipe,
    PlCalendarHeaderComponent,
    PlInfoboxComponent,
    PlClientLinkComponent,
    LoadingAnimationComponent,
    DateErrorPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatChipsModule,
    MatMenuModule,
    MatSortModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    PlApiModule,
    StoreModule.forFeature(featureKey, reducer),
    EffectsModule.forFeature([PlAccountEffects, PLFeatureFlagEffects]),
  ],
  exports: [
    PlSearchFilterComponent,
    PlTableComponent,
    PlButtonComponent,
    PlInputFileComponent,
    PlProgressCircleComponent,
    PlaceholderTextPipe,
    PlCalendarHeaderComponent,
    PlInfoboxComponent,
    PlClientLinkComponent,
    LoadingAnimationComponent,
    DateErrorPipe,
  ],
  providers: [
    PlModalService,
    PlUserService,
    UserProfileService,
    InternalAdminService,
  ],
})
export class PlCommonModule {}
